
//XXX cf separating out ratio? or having width & height for non-full?

import {Image} from 'Common/config/ImageTypes';


/* A4 (includes date header) */
export const eventPoster:Image = {
	ratio: 0.7071,
	minWidth:200,
	formats:['jpeg','png','webp'],

	medium: {width:528,format:'jpeg'},
	tiny: {width:100,format:'jpeg'},
};

/* A4 portrait, all sizes */
export const portrait:Image = {
	ratio: 0.7071,
	minWidth:100,
	formats:['jpeg','png','webp'],

	large: {width:1200,format:'jpeg'},
	medium: {width:600,format:'jpeg'},
	small: {width:400,format:'jpeg'},
	tiny: {width:100,format:'jpeg'}
};

//CJ added photoPortrait 4x5 ratio so we can keep VOS posters at total ratio of A4 including date bar
export const portrait4x5:Image = {
	ratio: 0.80,
	minWidth:100,
	formats:['jpeg','png','webp'],

	large: {width:1200,format:'jpeg'},
	medium: {width:600,format:'jpeg'},
	small: {width:400,format:'jpeg'},
	tiny: {width:100,format:'jpeg'}
};

//CJ added photoPortrait 4x5 ratio so we can keep VOS posters at total ratio of A4 including date bar
export const portrait10x11:Image = {
	ratio: 10/11,
	minWidth:100,
	formats:['jpeg','png','webp'],

	large: {width:1200,format:'jpeg'},
	medium: {width:600,format:'jpeg'},
	small: {width:400,format:'jpeg'},
	tiny: {width:100,format:'jpeg'}
};

/* Square, all sizes */
export const square:Image = {
	ratio: 1,
	minWidth:100,
	formats:['jpeg','png','webp'],

	large: {width:1200,format:'jpeg'},
	medium: {width:600,format:'jpeg'},
	small: {width:400,format:'jpeg'},
	tiny: {width:100,format:'jpeg'}
};

/* 3x2 landscape, all sizes */
export const landscape:Image = {
	ratio: 1.5,
	minWidth:100,
	formats:['jpeg','png','webp'],

	large: {width:1200,format:'jpeg'},
	medium: {width:600,format:'jpeg'},
	small: {width:400,format:'jpeg'},
	tiny: {width:100,format:'jpeg'}
};

export const landscape3x2Large:Image = {
	ratio: 1.5,
	minWidth:100,
	formats:['jpeg','png','webp'],

	large: {width:1200,format:'jpeg'},
};

export const facebookBanner:Image = {
	ratio: 1.91,
	minWidth:100,
	formats:['jpeg','png','webp'],

	large: {width:1200,format:'jpeg'},
	medium: {width:600,format:'jpeg'},
	small: {width:400,format:'jpeg'},
	tiny: {width:100,format:'jpeg'}
};

//IS this ratio around the wrong way? how can landscapeThreeTwo above = ratio 1.5 but this profile3x2 = ratio:0.6667
export const profile3x2:Image = {
	ratio: 0.6667,
	minWidth:100,
	formats:['jpeg','png','webp'],

	large: {width:800,format:'jpeg'},
	medium: {width:400,format:'jpeg'},
	small: {width:200,format:'jpeg'},
	tiny: {width:100,format:'jpeg'}
};

export const venueLogo:Image = {
	minWidth:500,
	formats:['jpeg','png','webp'],

	medium: {maxWidth:600,maxHeight:600,format:'jpeg'},
};

export const venuePhoto:Image = {
	ratio: 1.5,
	minWidth:800,
	formats:['jpeg','png','webp']
};


/* Component sizes. No transformations. */

export const compAny:Image = {
	minWidth: 0,
	formats:['jpeg','png','webp'],

	large: {maxWidth:1000,maxHeight:1000},
	medium: {maxWidth:600,maxHeight:600},
	tiny: {maxWidth:100,maxHeight:100}
};

export const comp1x1:Image = {
	ratio: 1,
	minWidth: 0,
	formats:['jpeg','png','webp'],

	large: {width:1000},
	medium: {width:600},
	tiny: {width:100}
};

export const comp3x2:Image = {
	ratio: 1.5,
	minWidth: 0,
	formats:['jpeg','png','webp'],

	large: {width:1200},
	medium: {width:800},
	tiny: {width:100}
};

export const comp2x3:Image = {
	ratio: 0.6667,
	minHeight: 0,
	formats:['jpeg','png','webp'],

	large: {width:800},
	medium: {width:533},
	tiny: {width:80}
};

